enum BuildVersion {
  MASTER = 'master',
  STAGING = 'staging',
  BETA = 'beta',
  DEVELOP = 'develop',
  SPRINT = 'sprint',
}

export default BuildVersion;
